

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { StocksContext } from '../../context/stock/StockContext';
import { SuppliersContext } from '../../context/supplier/SupplierContext';
import { CategoriesContext } from '../../context/category/CategoryContext';
import { DeletedStockNotice } from './DeletedStockNotice';
import { useRequiredFields } from '../../hooks/useRequiredFields';
import { costingApi, CRC, currencySymbol, formatCost, USD } from './costing';




export const StockPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { createStock, updateStock, loadUnits } = useContext(StocksContext);
    // Moneda del comercio: el costo de un producto nuevo se escribe en esa moneda (el promedio se lleva en ella)
    const [companyCurrency, setCompanyCurrency] = useState<number>(CRC);
    const { suppliers, loadSuppliers } = useContext(SuppliersContext);
    const { categories, loadCategories } = useContext(CategoriesContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const [units, setUnits] = useState([]);
    // Producto eliminado con el mismo código: se reactiva por defecto
    const [reactivate, setReactivate] = useState(true);

    var stock;

    if (state) {
        stock = state.stock;
    } else {
        stock = {
            id: -1,
            code: '',
            name: '',
            categoryId: -1,
            unit: -1,
            newStock: '',
            supplierId: -1,
            minimunStock: '',
            cost: '',
            currency: 840
        }
    }


    const { formState, onInputChange } = useForm({
        ...stock,
        expirationDate: stock.expirationDate ? String(stock.expirationDate).slice(0, 10) : '',
        expirationNoticeDays: stock.expirationNoticeDays ?? '',
    });

    const { id, code, name, categoryId, unit, newStock, supplierId, minimunStock, cost, expirationDate, expirationNoticeDays } = formState

    // Fecha de vencimiento: opcional por producto
    const [handlesExpiration, setHandlesExpiration] = useState(!!stock.expirationDate);
    const noticeDaysValid = expirationNoticeDays === '' || /^\d+$/.test(String(expirationNoticeDays));

    /*useEffect(() =>{
      const formValid = name.length > 0 && unit != -1
      setIsFormValid(formValid);
    }, [name, unit])*/

    useEffect(() => {
        loadUnits().then((unis) => setUnits(unis));
    }, [])

    useEffect(() => {
        costingApi.configuration().then((r) => { if (r.data?.currency) setCompanyCurrency(Number(r.data.currency) === USD ? USD : CRC); });
    }, [])

    useEffect(() => {
        loadSuppliers(0);
    }, [])

    useEffect(() => {
        loadCategories();
    }, [])



    const handleSave = async () => {

        if (handlesExpiration && (!expirationDate || !noticeDaysValid)) {
            required.fail();
            setErrorMessage(!expirationDate ? "Debe indicar la fecha de vencimiento" : "Los días de aviso deben ser un número entero mayor o igual a 0");
            return false;
        }
        const expirationFields = handlesExpiration
            ? { expirationDate, expirationNoticeDays: expirationNoticeDays === '' ? 0 : parseInt(expirationNoticeDays) }
            : { expirationDate: null, expirationNoticeDays: null };

        var resp = "";
        if (id > 0) {
            const formValid = code.length > 0 && name.length > 0 && unit != -1 && categoryId != -1;
            if (!formValid) {
                required.fail();
                setErrorMessage("Debe completar los campos requeridos");
                return false;
            }

            resp = await updateStock({ ...formState, ...expirationFields });
        } else {
            const formValid = code.length > 0 && name.length > 0 && unit != -1 && categoryId != -1 && newStock != '' && parseInt(newStock) > -1;
            if (!formValid) {
                required.fail();
                setErrorMessage("Debe completar los campos requeridos");
                return false;
            }
            if (newStock == '') {
                formState.newStock = 0;
            }
            if (minimunStock == '') {
                formState.minimunStock = 0;
            }
            let wasReactivated = false;
            // La existencia inicial entra al costo indicado, en la moneda del comercio
            resp = await createStock({ ...formState, currency: companyCurrency, ...expirationFields, reactivate }, (_stock, reactivated) => { wasReactivated = reactivated; });
            if (resp == "success" && wasReactivated) {
                setSuccessMessage("El producto se reactivó en el inventario y conserva su historial de movimientos.");
                return;
            }
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Inventario actualizado correctamente" : "Inventario creado correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar producto del inventario' : 'Agregar producto a inventario'}</h3>
                <hr />

                <form className="row g-3 " >

                    {/* <div className="mb-3">
                    <label htmlFor="typeServiceSelect" className="form-label">Tipo de servicio</label>
                    <select id='typeServiceSelect' className="form-select" name='serviceTypeId' value={serviceTypeId} onChange={ onInputChange }  >
                    <option key={0} value={-1} >Seleccione una opción</option>
                    {units.length > 0
                    ?
                    units.map(service => (
                        <option key={service.id} value={service.id} >{service.description}</option>
                      ))
                    :
                    <option selected>No hay servicios disponibles</option>
                    }
                   </select>
                </div> */}



                    <div className="mb-3">
                        <label htmlFor="stockCodeInput" className="form-label">Código *</label>
                        <input
                            id='stockCodeInput'
                            type="text"
                            className={`form-control${required.mark(!code)}`}
                            placeholder="Código del producto"
                            name="code"
                            value={code}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    {id < 0 && (
                        <DeletedStockNotice
                            code={code}
                            reactivate={reactivate}
                            onReactivateChange={setReactivate}
                        />
                    )}

                    <div className="mb-3">
                        <label htmlFor="stockNameInput" className="form-label">Nombre *</label>
                        <input
                            id='stockNameInput'
                            type="text"
                            className={`form-control${required.mark(!name)}`}
                            placeholder="Nombre"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="categorySelect" className="form-label">Categoría *</label>
                        <div className="d-flex gap-2">
                            <select id='categorySelect' className={`form-select${required.mark(categoryId == -1)}`} name='categoryId' value={categoryId} onChange={onInputChange}  >
                                <option key={0} value={-1} >Seleccione una opción</option>
                                {categories.length > 0
                                    ?
                                    categories.map(cat => (
                                        <option key={cat.id} value={cat.id} >{cat.name}</option>
                                    ))
                                    :
                                    <option disabled>No hay categorías configuradas</option>
                                }
                            </select>
                            <div className="invalid-feedback">Campo requerido</div>
                            <button
                                type="button"
                                className="btn btn-outline-secondary text-nowrap"
                                onClick={() => navigate("/category")}
                            >
                                <i className="bi bi-plus-lg" /> Nueva
                            </button>
                        </div>
                    </div>

                    {
                        id < 0 ? (<div className="mb-3">
                            <label htmlFor="stockInput" className="form-label">Cantidad *</label>
                            <input
                                id='stockInput'
                                type="text"
                                className={`form-control${required.mark(id <= 0 && (newStock === '' || !(parseInt(newStock) > -1)))}`}
                                placeholder="Cantidad"
                                name="newStock"
                                value={newStock}
                                onChange={onInputChange}
                                required
                            />
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>)
                            : <div></div>
                    }





                    <div className="mb-3">
                        <label htmlFor="unitSelect" className="form-label">Unidad de Medida *</label>
                        <select id='unitSelect' className={`form-select${required.mark(unit == -1)}`} name='unit' value={unit} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {units.length > 0
                                ?
                                units.map(service => (
                                    <option key={service.id} value={service.id} >{service.description}</option>
                                ))
                                :
                                <option selected>No hay unidad de medida configuradas</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>




                    <div className="mb-3">
                        <label htmlFor="supplierSelect" className="form-label">Proveedor</label>
                        <select id='supplierSelect' className="form-select" name='supplierId' value={supplierId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {suppliers.length > 0
                                ?
                                suppliers.map(service => (
                                    <option key={service.supplierCode} value={service.supplierCode} >{service.name}</option>
                                ))
                                :
                                <option selected>No hay proveedores configurados</option>
                            }
                        </select>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="minimunStockInput" className="form-label">Cantidad mínima</label>
                        <input
                            id='minimunStockInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Cantidad mínima"
                            name="minimunStock"
                            value={minimunStock}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    {id > 0 ? (
                        <div className="mb-3">
                            <label htmlFor="costStockInput" className="form-label">Costo promedio</label>
                            <input
                                id='costStockInput'
                                type="text"
                                className="form-control"
                                value={stock.averageCost === null || stock.averageCost === undefined ? '-' : formatCost(stock.averageCost, companyCurrency)}
                                readOnly
                                disabled
                            />
                            <div className="form-text">Lo calcula el sistema con cada compra. Solo el administrador del portal lo puede ajustar, desde el kardex.</div>
                        </div>
                    ) : (
                        <div className="mb-3">
                            <label htmlFor="costStockInput" className="form-label">Costo unitario ({currencySymbol(companyCurrency)})</label>
                            <input
                                id='costStockInput'
                                type="number"
                                className={`form-control `}
                                placeholder="Costo"
                                name="cost"
                                value={cost}
                                onChange={onInputChange}
                                required
                            />
                            <div className="form-text">Costo de la existencia inicial. Después, el costo se calcula con las compras.</div>
                        </div>
                    )}

                    <div className="mb-3">
                        <div className="form-check form-switch">
                            <input
                                id='handlesExpirationInput'
                                className="form-check-input"
                                type="checkbox"
                                checked={handlesExpiration}
                                onChange={(e) => setHandlesExpiration(e.target.checked)}
                            />
                            <label htmlFor="handlesExpirationInput" className="form-check-label">Maneja fecha de vencimiento</label>
                        </div>
                    </div>

                    {handlesExpiration && (
                        <div className="row g-3 mt-0">
                            <div className="col-sm-6">
                                <label htmlFor="expirationDateInput" className="form-label">Fecha de vencimiento *</label>
                                <input
                                    id='expirationDateInput'
                                    type="date"
                                    className={`form-control${required.mark(!expirationDate)}`}
                                    name="expirationDate"
                                    value={expirationDate}
                                    onChange={onInputChange}
                                />
                                <div className="invalid-feedback">Campo requerido</div>
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="expirationNoticeDaysInput" className="form-label">Días de aviso antes del vencimiento</label>
                                <input
                                    id='expirationNoticeDaysInput'
                                    type="text"
                                    inputMode="numeric"
                                    className={`form-control onlyInteger${required.mark(!noticeDaysValid)}`}
                                    placeholder="0"
                                    name="expirationNoticeDays"
                                    value={expirationNoticeDays}
                                    onChange={onInputChange}
                                />
                                <div className="form-text">Desde esa cantidad de días antes, el inventario lo marca como "Por vencer".</div>
                            </div>
                        </div>
                    )}

                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
